import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { MapPin, Calendar } from "lucide-react";
import "./Experience.css";

const Experience = ({ data }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, threshold: 0.2 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="experience" id="experience" ref={ref}>
      <div className="container">
        <motion.div
          className="experience-content"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.div className="section-header" variants={itemVariants}>
            <h2 className="section-title">Work Experience</h2>
            <div className="section-line"></div>
          </motion.div>

          <div className="timeline">
            {data.workExp.map((job, index) => (
              <motion.div
                key={index}
                className="timeline-item"
                variants={itemVariants}
              > 
                <div className="timeline-marker">
                  <div className="timeline-dot"></div>
                  {index < data.workExp.length - 1 && (
                    <div className="timeline-line"></div>
                  )}
                </div>

                <div className="timeline-content">
                  <div className="job-header">
                    <div className="job-image">
                      <img src={job.image} alt={job.Name} />
                    </div>
                    <div className="job-info">
                      <h3 className="job-company">{job.Name}</h3>
                      <div className="job-meta">
                        <div className="job-location">
                          <MapPin size={16} />
                          <span>{job.location}</span>
                        </div>
                        <div className="job-duration">
                          <Calendar size={16} />
                          <span>
                            {job.from} - {job.to}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="job-summary">
                    <p>{job.JobSummary}</p>
                  </div>

                  <div className="job-responsibilities">
                    <h4>Key Responsibilities:</h4>
                    <ul>
                      {job.KeyResponsibilities.filter(
                        (resp) => resp !== null
                      ).map((responsibility, idx) => (
                        <li key={idx}>{responsibility}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="job-skills">
                    <h4>Skills & Accomplishments:</h4>
                    <div className="skills-tags">
                      {job.SkillsAccomplishments.map((skill, idx) => (
                        <span key={idx} className="skill-tag">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
